import App from './App';
import ReactDOM from 'react-dom/client';
import { AlertProvider, ModalProvider } from '@fs/core';
import { queryClient, FsThemeContextProvider } from '@fs/utils';
import { QueryClientProvider } from 'react-query';
import { PlayerProvider } from '@fs/player';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { initializeSentry } from './sentrySetup';
import FsUserContextProvider from './common/contexts/UserInfoContext';
import './i18nConfig';
import './index.css';

/** Same default as eflix-panel; override with VITE_GOOGLE_OAUTH_CLIENT_ID for other environments. */
const GOOGLE_OAUTH_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID ??
  '558632942729-8veati9e7d54i358qkts4ohbacb2k2l1.apps.googleusercontent.com';

async function purgeDevServiceWorkers() {
  if (!import.meta.env.DEV) {
    return;
  }

  const hasServiceWorker = 'serviceWorker' in navigator;
  if (!hasServiceWorker) {
    return;
  }

  const hasPurged = window.sessionStorage.getItem('__DEV_SW_PURGED__') === '1';
  if (hasPurged) {
    return;
  }

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    if (registrations.length === 0) {
      window.sessionStorage.setItem('__DEV_SW_PURGED__', '1');
      return;
    }

    await Promise.all(registrations.map((reg) => reg.unregister()));
    if ('caches' in window) {
      const keys = await window.caches.keys();
      await Promise.all(keys.map((k) => window.caches.delete(k)));
    }

    window.sessionStorage.setItem('__DEV_SW_PURGED__', '1');
    window.location.reload();
  } catch {
    window.sessionStorage.setItem('__DEV_SW_PURGED__', '1');
  }
}

initializeSentry();
void purgeDevServiceWorkers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <FsThemeContextProvider>
    <QueryClientProvider client={queryClient}>
      <FsUserContextProvider>
        <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
          <AlertProvider>
            <ModalProvider>
              <PlayerProvider>
                <App />
              </PlayerProvider>
            </ModalProvider>
          </AlertProvider>
        </GoogleOAuthProvider>
      </FsUserContextProvider>
    </QueryClientProvider>
  </FsThemeContextProvider>
);
